/**
 * /support/handoffs
 *
 * The second seat on the Ellie bridge. The SMS path to the owner's phone stays; whichever
 * seat answers first clears the clock.
 */
import { useState } from 'react';
import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from '../_shell';
import { HandoffList, HandoffWorkspace } from '@/features/support/HandoffConsole';

function HandoffsPage() {
  const [open, setOpen] = useState<number | null>(null);
  return (
    <div style={{ display: 'grid', gap: 'var(--space-4)' }}>
      <HandoffList onOpen={setOpen} />
      {open === null ? null : <HandoffWorkspace handoffId={open} />}
    </div>
  );
}

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/support/handoffs',
  component: HandoffsPage,
});
